import { CellSelections } from '../../../../../common/table/TableTypes';
import { getAllSelectedCols } from './tableSelectionGeometryUtils';
import { isColInSelections, isRowInSelection } from './tableSelectionPredicateUtils';

/**
 * Resolves which columns should participate in a resize gesture for the given resized column.
 */
export const getResizeTargetColumns = (
    selections: CellSelections | null | undefined,
    resizeColumn: number,
): number[] => {
    if (!selections) return [resizeColumn];

    const headerSelections = selections.reduce<CellSelections>(
        (acc, selection) => (isRowInSelection(-1, selection) ? [...acc, selection] : acc),
        [],
    );

    if (headerSelections.length && isColInSelections(resizeColumn, headerSelections)) {
        return getAllSelectedCols(headerSelections);
    }

    return [resizeColumn];
};
